export default {
  locale: {
    presence: { allowEmpty: false, message: 'is required' },
  },
};
